import React from 'react';
import {
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
  Form
} from 'reactstrap';

import { getAccountDetails } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { getMembershipUsers, DeleteMembershipUser, inviteMember, InviteManualUser } from '../../../../../Redux/Actions/EndUser/MemberInvitationAction';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import ManualUserForm from './ModalForms/ManualUserForm';
import PortalUserForm from './ModalForms/PortalUserForm';
import InviteUserForm from './ModalForms/InviteUserForm';
import { toastr, RemoveEmailMessage } from '../../../../../Redux/Actions/CommonActions';
import { Alert } from 'reactstrap';
import { withRouter } from 'react-router';
import './AuthorizedMembers.scss';
import { isDebuggerStatement } from '@babel/types';
import EditMembershipUserForm from '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/ModalForms/EditMembershipUserForm';

class AuthorizedMembers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canInvite: false,
      emailMatches: false,
      modal: false,
      isNotManual: true,
      userModel: {},
      membershipId: 0,
      message: "",
      membershipCountMessage: "",
      foundUser: {},
      membershipscount: 0,
      membershipUserInEdit: null
    };
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      canInvite: false,
      emailMatches: false
    }));
    this.props.RemoveEmailMessage();
  };

  componentDidMount() {
    //const membershipId = this.props.accountDetails.selectedMember.membershipId;
    this.setState({
      membershipId: this.props.accountDetails.selectedMember.membershipId
    })
    this.props.getAccountDetails(auth.getAuthUserEmail());
    this.props.getMembershipUsers(this.props.accountDetails.selectedMember.membershipId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.emailMatches === false && this.props.common.emailMessage === 'This email matches an email associated with a user in the portal. This invitation will be sent to that user.') {
      this.setCanInvite();
    }

    if (prevProps.membershipUsers !== this.props.membershipUsers) {
      this.SearchOwner()
    }
  }

  setCanInvite() {
    this.setState({
      canInvite: true,
      emailMatches: true
    })
  }

  portalUserStateChange = (userModel) => {
    this.props.common.emailMessage = '';
    this.setState({
      userModel: userModel,
      canInvite: false,
      emailMatches: false
    })
  }
  manualUserStateChange = (userModel) => {
    this.setState({
      userModel: userModel
    })
  }
  inviteUserStateChange = (userModel) => {
    this.setState({
      userModel: userModel
    })
  }
  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({
      membershipCountMessage: ""
    });

    const edited = this.state.userModel;
    edited.memberSequenceNum = this.props.membershipUsers.length;

    if (this.state.userModel.email === "") {
      this.props.InviteManualUser(edited);
    }
    else if (this.state.userModel.email !== this.props.details.userName) {
      this.props.inviteMember(edited);
    }
    else {
      this.setState({
        message: "You are already part of this Organization"
      })
    }
    this.setState((prevState) => ({
      modal: !prevState.modal
    }));
  };

  Delete = (event) => {
    this.setState({
      membershipCountMessage: ""
    })
    event.isActive = false;
    this.props.DeleteMembershipUser(event);
  };
  Activate = (event) => {
    this.setState({
      membershipCountMessage: ""
    })
    console.log("activate event", event)
    //var count = this.props.details.additionalMemberships - this.props.details.existingMemberships ;
    if (this.state.membershipscount > 0) {
      event.isActive = true;
      this.props.DeleteMembershipUser(event);

    }
    else {
      this.setState({
        membershipCountMessage: "You dont have memebership's available to activate user"
      })
    }
  };

  SearchOwner = () => {
    this.props.membershipUsers.length > 0 ? this.props.membershipUsers.find((element) => {
      if (element.isMembershipOwner && element.userId === this.props.authentication.user.userId) {
        this.setState({
          foundUser: element,
          membershipscount: element.additionalMemberships - element.existingMemberships
        })
      }

    }) : this.setState({
      foundUser: {}
    });
  }

  editUser = (memberNumber) => {
    let m = this.props.membershipUsers.filter(a => a.memberNumber == memberNumber)[0];
    this.setState({
      membershipUserInEdit: m
    });
  }

  returnFromEdit = () => {
    this.setState({
      membershipUserInEdit: null
    });
  }

  completeUpdatedInvite = (model) => {
    this.returnFromEdit();
    const membershipId = this.props.accountDetails.selectedMember.membershipId;
    this.setState({
      membershipId: membershipId
    })
    this.props.getMembershipUsers(this.props.accountDetails.selectedMember.membershipId);
  }

  render() {
    let counter = 0;
    if (this.props.getting)
      return (
        <div>
          <IsLoading />
        </div>
      );
    return (
      <React.Fragment>
        {this.props.common.visible ? (
          <Alert
            color={this.props.common.color}
            isOpen={this.props.common.visible}
            style={{ position: 'fixed', width: '100%' }}
          >
            {this.props.common.message}
          </Alert>
        ) : null}
        <div className="account-tab-content authorized-members">
          <div>
            <div>
              <div>

                <h1 className="pt-3 pb-3">Authorized Members</h1>

                <div className="account-tab-content-right">

                  {this.state.foundUser ?
                    <div>
                      <label className="info-text">
                        You have <span className="highlight">{this.state.membershipscount > 0 ? this.state.membershipscount : 0}</span> of <span className="highlight">{this.state.foundUser.additionalMemberships}</span> additional memberships available
                      </label>

                      <Button
                        color="primary"
                        size="sm"
                        disabled={this.state.membershipscount <= 0}
                        className={this.state.membershipscount >= 0 ? "btnPrimary authorizemember" : ""}
                        onClick={this.toggleModal}
                      >
                        ADD AUTHORIZED MEMBER
                      </Button>
                    </div>
                    : ""
                  }
                </div>
              </div>
              <div className="table-responsive">
                <Table hover className="edit-account-form card">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Member #</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Address 1</th>
                      <th>Address 2</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Zip</th>
                    </tr></thead><tbody>
                    {this.props.membershipUsers.length > 0 ? this.props.membershipUsers.map((item, i) => {
                      counter = item.isMembershipOwner ? counter : counter + 1;
                      return (
                        <tr key={`authorized-members-${i}`}>
                          <th scope="row">{item.isPendingInvitation ? "Pending" : [i + 1]}</th>
                          <td>{item.isMembershipOwner ? item.memberNumber : item.memberNumber + "-" + counter}</td>
                          <td>{item.firstName}</td>
                          <td>{item.lastName}</td>
                          <td>{item.userName != null ? item.userName : <label onClick={() => this.editUser(item.memberNumber)} style={{ color: "blue", cursor: "pointer" }}>Click to Invite</label>}</td>
                          <td>{item.address1}</td>
                          <td>{item.address2}</td>
                          <td>{item.city}</td>
                          <td>{item.state.description}</td>
                          <td>{item.zip}</td>
                          {(this.state.foundUser.isMembershipOwner) ?
                            (!item.isMembershipOwner) && (item.isActive) && (Number(item.membershipId) === Number(this.state.membershipId)) ?
                              <td>
                                <Button
                                  color="primary"
                                  size="sm"
                                  className="btnPrimary"
                                  onClick={() => this.Delete(item)}
                                >REMOVE</Button></td>
                              : ""
                            : ""}
                          {(item.isMembershipOwner) && (!item.isActive) && (Number(item.membershipId) === Number(this.state.membershipId)) ?
                            <td>
                              <Button
                                color="primary"
                                size="sm"
                                className={"btnSecondary"}
                                onClick={() => this.Activate(item)}
                              >ACTIVATE</Button>
                              <p style={{ whiteSpace: "nowrap", color: "red" }}>{this.state.membershipCountMessage}</p>
                            </td> : ""}
                        </tr>
                      );

                    }) : ""
                    }
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          {this.state.membershipUserInEdit == null ?
            <Form onSubmit={this.handleSubmit}>
              <Modal className="modal-lg modal-authorized k-window-content" isOpen={this.state.modal} toggleModal={this.toggleModal}>
                <ModalHeader>Add Authorized Member</ModalHeader>
                <div className="user-form">
                  <div>
                    <FormGroup check>
                      <Row>
                        <Col>
                          <Input
                            type="radio"
                            name="radio1"
                            id="radio1"
                            defaultChecked
                            className="custom-control-input"
                            onClick={() => this.setState({ isNotManual: true })}
                          />{' '}
                          <Label check htmlFor="radio1">
                            <span className={this.state.isNotManual === true ? "fas fa-check-circle" : "far fa-circle"}></span>
                            <span className="form-check-text">Member has an email address</span>
                          </Label>
                          <Input
                            type="radio"
                            name="radio2"
                            id="radio2"
                            className="custom-control-input"
                            onClick={() => {
                              this.props.RemoveEmailMessage();
                              this.setState({ isNotManual: false })
                            }}
                          />{' '}
                          <Label check htmlFor="radio2">
                            <span className={this.state.isNotManual === false ? "fas fa-check-circle" : "far fa-circle"}></span>
                            <span className="form-check-text">Member does not have an email address</span>
                          </Label>
                        </Col>
                      </Row>
                    </FormGroup>
                  </div>
                  <ModalBody>{!this.state.isNotManual ? <ManualUserForm manualUserStateChange={this.manualUserStateChange} handleSubmit={this.handleSubmit} cancel={this.toggleModal} /> : <PortalUserForm portalUserStateChange={this.portalUserStateChange} message={this.state.message} />}</ModalBody>
                  <ModalBody>{(this.props.common.emailMessage === "User does not exist. Please create the user.") ? <InviteUserForm handleSubmit={this.handleSubmit} cancel={this.toggleModal} inviteUserStateChange={this.inviteUserStateChange} email={this.state.userModel.email} /> : ""} </ModalBody>

                  {!this.state.isNotManual || this.props.common.emailMessage === "User does not exist. Please create the user." ?
                    null
                    :
                    <ModalFooter>
                      <button
                        type="submit"
                        className="btn btnPrimary admin-k-button"
                        onClick={this.handleSubmit}
                        disabled={!this.state.canInvite}
                      >
                        <i className="fas fa-paper-plane"></i>
                        <span>Send Invite</span>
                      </button>
                      <button className="btn btn-cancel btnSecondary admin-k-button authorizedUsrCancelBtn" onClick={this.toggleModal}>
                        <i className="fas fa-times"></i>
                        <span>CANCEL</span>
                      </button>
                    </ModalFooter>
                  }
                </div>
              </Modal>
            </Form>
            :
            <Modal className="modal-lg modal-authorized k-window-content" isOpen={this.state.membershipUserInEdit}>
              <EditMembershipUserForm
                membershipUserInEdit={this.state.membershipUserInEdit}
                cancel={this.returnFromEdit}
                membershipId={this.state.membershipId}
                completeUpdatedInvite={this.completeUpdatedInvite}
              />
            </Modal>}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    details: state.accountDetails.details,
    getting: state.accountDetails.getting,
    membershipUsers: state.memberInvitation.membershipUsers,
    common: state.common,
    authentication: state.authentication,
    accountDetails: state.accountDetails
  };
}

export default withRouter(connect(mapStateToProps, {
  getAccountDetails, inviteMember, getMembershipUsers, toastr, DeleteMembershipUser, InviteManualUser, RemoveEmailMessage
})(AuthorizedMembers));
